import httpService from "./http.service";

class CurrenciesService {
  getCurrenciesUrl = "/currencies";

  getCurrencies = (query) => {
    return httpService.get(`/currencies?${query}`);
  };
  getAllCurrencies = () => {
    return httpService.get("/currencies/all");
  };
  createCurrency = (model) => {
    return httpService.post("/currencies", model);
  };
  editCurrency = (id, model) => {
    return httpService.patch("/currencies/" + id, model);
  };
  deleteCurrency = (id) => {
    return httpService.delete("/currencies/" + id);
  };
}

const currenciesService = new CurrenciesService();
export default currenciesService;
